<template>
	<div>
		<div class="d-flex-between-center align-items-start m-d-8"
		     v-for="(layanan, i) in transaksi.rincian_layanan" :key="i"
		>
			<div class="d-block" style="max-width: 70%;">
				<div class="f-regular f-14 f-c-black">
					{{ layanan.nama_paket }}
				</div>
				<div class="f-regular f-12 f-c-midgrey">
					Aktif {{ 0 >= layanan.jumlah_hari_aktif ? 'Selamanya' : layanan.jumlah_hari_aktif + " hari" }}
				</div>
			</div>
			<div class="d-block text-right">
				<div class="f-regular f-14 f-c-black">
					{{ formatRupiah(layanan.harga_satuan) }}
				</div>
				<div class="f-regular f-12 f-c-black" v-if="layanan.bonus_saldo > 0">
					<span class="f-c-midgrey">+ bonus</span> {{ formatRupiah(layanan.bonus_saldo) }}
				</div>
			</div>
		</div>

		<div class="f-regular f-12 f-c-midgrey">
			{{ transaksi.detail_transaksi.masa_aktif_formated }}
		</div>
		<div class="f-regular f-12 f-c-midgrey">
			Saldo awal {{ formatRupiah(transaksi.detail_transaksi.saldo_awal) }}
		</div>
		<div class="f-regular f-12 f-c-midgrey">
			Saldo akhir {{ formatRupiah(transaksi.detail_transaksi.saldo_akhir) }}
		</div>
		<div class="separator-line-dot m-t-4 m-d-12"></div>
	</div>
</template>

<script>
export default {
	name: "SOTagihanTopupEpayment",
	props: {
		transaksi: Object,
	}
}
</script>